'use strict';

import { dataMember, required } from 'santee-dcts';

export class Study {

    @dataMember()
    @required()
    public studyId: number;

    @dataMember()
    @required()
    public sponsor: string;

    @dataMember()
    @required()
    public clientProtocol: string;

    @dataMember()
    @required({ nullable: true })
    public covanceProjectNumber: string;

    public get studyUrlParameter() {
        return this.covanceProjectNumber || `studyId:${this.studyId}`;
    }
}